var map = {
	"./avatar_controller.ts": 1363,
	"./char_counter_controller.ts": 8677,
	"./couponing/book_purchases_controller.ts": 640,
	"./couponing/home_controller.ts": 9722,
	"./coupons_controller.ts": 7726,
	"./draft_updater_controller.ts": 9139,
	"./statistics_controller.ts": 5463,
	"controllers/avatar_controller.ts": 1363,
	"controllers/char_counter_controller.ts": 8677,
	"controllers/couponing/book_purchases_controller.ts": 640,
	"controllers/couponing/home_controller.ts": 9722,
	"controllers/coupons_controller.ts": 7726,
	"controllers/draft_updater_controller.ts": 9139,
	"controllers/statistics_controller.ts": 5463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1336;